import { EinzaGraphiQLService } from "@/services/einzaGraphiQL"

import { calculateSummary, rearrangeAndEnrichRevenueData } from "./revenueByAhg"

export const revenueStatsByArticleMainGroup = async ({ admNumber, customerNumber, year, month } = {}) => {
  const currentYear = year && year > 0 ? year : new Date().getFullYear()
  const currentMonth = month && month > 0 ? month : new Date().getMonth() + 1
  const lastYear = currentYear - 1

  const methodName = getDbQueryMethodName(month, customerNumber)
  const fields = ["articleMainGroup", "year", ...(month ? ["month"] : []), "revenue", "margin"]

  const graphiQLQueryObject = [
    {
      method: `currentYearRevenue: ${methodName}`,
      variables: {
        ...(customerNumber ? { customerNumber } : { admNumber }),
        year: currentYear,
        ...(month && { month: currentMonth }),
      },
      fields,
    },
    {
      method: `lastYearRevenue: ${methodName}`,
      variables: {
        ...(customerNumber ? { customerNumber } : { admNumber }),
        year: lastYear,
        ...(month && { month: currentMonth }),
      },
      fields,
    },
  ]
  const mappedQuery = EinzaGraphiQLService.formQuery(graphiQLQueryObject)
  const queryResponse = (await EinzaGraphiQLService.getData(mappedQuery))?.data

  if (!queryResponse) throw new Error("Data retrieval for revenue stats failed")

  const { currentYearRevenue, lastYearRevenue } = queryResponse

  const statsByArticleMainGroup = rearrangeAndEnrichRevenueData({
    currentYearRevenue,
    lastYearRevenue,
  })

  const summary = calculateSummary(statsByArticleMainGroup)

  return { summary, revenueStats: statsByArticleMainGroup }
}

const getDbQueryMethodName = (hasMonth, customerNumber) => {
  if (customerNumber) {
    return hasMonth ? "customerStatsByArticleMainGroupByMonth" : "customerStatsByArticleMainGroup"
  }
  return hasMonth ? "admStatsByArticleMainGroupByMonth" : "admStatsByArticleMainGroup"
}
